// extracted by mini-css-extract-plugin
export default {"userDetails__collapseCell":"ProjectUserTableRow_userDetails__collapseCell__BEdq8"};